@if(fileImportSummaryData.length) {
<div class="col-12 flex align-items-center justify-content-start gap-2">
    <h3>Date : <span class="font-normal">{{ fileImportSummaryData[0]['date'] }}</span></h3>
    <p-button severity="success" label="Import Daily Summary" (onClick)="importSummaryData()"
        [loading]="importSummaryInProgress" />
    <p-button severity="warning" label="Clear Previous Daily Summary Import" (onClick)="clearSummaryData()"
        [loading]="importSummaryInProgress" />
</div>

<div class="col-12">
    <p-table [value]="fileImportSummaryData[0]['cashier_summary']['rows']"
        [columns]="fileImportSummaryData[0]['cashier_summary']['columns']">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                Cashier Summary
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let column of columns">{{column.header}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    {{ col?.prefix }} {{ customer[col.field] }}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td *ngFor="let col of fileImportSummaryData[0]['cashier_summary']['columns']">
                    {{ fileImportSummaryData[0]['cashier_summary']['summary'][0][col.field] }}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="columns.length" class="text-center font-bold">No Cashier Summary Found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<div class="col-12">
    <p-table [value]="fileImportSummaryData[0]['cashier_ticket_summary']['rows']"
        [columns]="fileImportSummaryData[0]['cashier_ticket_summary']['columns']">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                Cashier Tickets Summary
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let column of columns">{{column.header}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    {{ col?.prefix }} {{ customer[col.field] }}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td *ngFor="let col of fileImportSummaryData[0]['cashier_ticket_summary']['columns']">
                    {{ fileImportSummaryData[0]['cashier_ticket_summary']['summary'][0][col.field] }}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="columns.length" class="text-center font-bold">No Cashier Tickets Summary Found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>
}